import './404.scss';

const NotFound = () => (
  <div className="not-found">
    <h1>This page doesn't exist!</h1>
  </div>
);

export default NotFound;
